import React from 'react';

interface OnboardingStyleWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const OnboardingStyleWrapper: React.FC<OnboardingStyleWrapperProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`onboarding-container max-w-2xl mx-auto ${className}`}>
      <div className={`onboarding-card bg-white rounded-3xl shadow-xl p-8 ${className.includes('onboarding-card-gradient') ? '' : 'bg-white'}`}>
        {children}
      </div>
    </div>
  );
};

export default OnboardingStyleWrapper;